import * as THREE from "three";
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
/**
 * 加载主车模型；
 * @returns  加载主车模型的promise；
 */
export function loadVehicle(modelname) {
    return new Promise((resolve, reject) => {
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('libs/draco/gltf/')
        const loader = new GLTFLoader()
        loader.setDRACOLoader(dracoLoader)
        loader.load(`model/gltf/${modelname}`, (gltf) => {
            const box = new THREE.Box3();
            box.expandByObject(gltf.scene)
            let v3=new THREE.Vector3()
            box.getSize(v3)
            gltf.scene.up= new THREE.Vector3(0, 0, 1)
            gltf.scene.size=v3;
            gltf.scene.scale.set(3.7 / v3.x, 2.15 / v3.y, 1.5 / v3.z)
            resolve(gltf.scene);
        }, null, (err) => {
            reject(err);
        })
    })
}

export function loadOBJModel(setting) {
    var mtlLoader = new MTLLoader();
    mtlLoader.setPath('model/obj/');
    mtlLoader.load(`${setting.path}/file.mtl`, function (materials) {
        materials.preload();
        var objLoader = new OBJLoader();
        objLoader.setMaterials(materials);
        objLoader.setPath('model/obj/');
        objLoader.load(`${setting.path}/file.obj`, function (object) {
            object.scale.set(setting.scale.x, setting.scale.y, setting.scale.z)
        });
    });
}